import { Grid, Typography, Box } from "@mui/material";
import { useForm } from "../../../providers/FormProvider";

export default function EasyFormPage() {
  const { form } = useForm();

  return (
    <Box>

    </Box>
  );
}
